import { Divider, SxProps, Theme } from '@mui/material';
import { getSidenavSeparatorColor } from '../sidenav-colors';
import { SIDENAV_TOKENS } from '../sidenav-tokens';

/**
 * Subtle horizontal rule between sidenav sections.
 * Inset so it does not read as an edge-to-edge wall.
 */
export function NavSeparator(p: { className?: string; sx?: SxProps }) {
  return (
    <Divider
      className={p.className}
      sx={
        [
          (theme: Theme) => ({
            mx: SIDENAV_TOKENS.contentPaddingX,
            borderColor: getSidenavSeparatorColor(theme),
          }),
          p.sx ?? {},
        ] as SxProps
      }
    />
  );
}
